// Sub-modal "Programar envío" (presets tipo Gmail + fecha custom validada).
// Extraído de EnviarCorreoModal (modularización 2026-06-11).
import { useState } from "react";
import Modal from "@/ui/Modal";
import { useToast } from "@/ui/Toast";
import {
  fmtFechaCorta,
  manana,
  minProgramable,
  proximoLunes,
} from "@/components/correo/utilsCorreo";

export default function ProgramarEnvioModal({
  open,
  onOpenChange,
  onProgramar,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  /** Recibe la fecha elegida en ISO; el caller dispara el envío. */
  onProgramar: (iso: string) => void;
}) {
  const toast = useToast();
  const [scheduledCustom, setScheduledCustom] = useState("");

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Programar envío"
      description="El correo se guarda y sale solo a la fecha que elijas."
      size="sm"
    >
      <div className="space-y-2">
        {[
          { label: "Mañana en la mañana", date: manana(8) },
          { label: "Mañana en la tarde", date: manana(13) },
          { label: "El lunes en la mañana", date: proximoLunes(8) },
        ].map((p) => (
          <button
            key={p.label}
            type="button"
            onClick={() => {
              onOpenChange(false);
              onProgramar(p.date.toISOString());
            }}
            className="w-full text-left rounded border border-ink-700 hover:bg-ink-800 px-3 py-2 transition"
          >
            <div className="text-sm text-zinc-200">{p.label}</div>
            <div className="text-xs text-zinc-500">{fmtFechaCorta(p.date)}</div>
          </button>
        ))}
        <div className="border-t border-ink-700 pt-3">
          <label className="text-xs text-zinc-500 block mb-1">
            Otra fecha y hora
          </label>
          <div className="flex flex-col gap-2 sm:flex-row">
            <input
              type="datetime-local"
              min={minProgramable()}
              value={scheduledCustom}
              onChange={(e) => setScheduledCustom(e.target.value)}
              className="input w-full sm:flex-1 text-sm"
            />
            <button
              type="button"
              disabled={!scheduledCustom}
              onClick={() => {
                const fecha = new Date(scheduledCustom);
                if (Number.isNaN(fecha.getTime()) || fecha.getTime() <= Date.now()) {
                  toast.error("Fecha inválida", "Elige una fecha y hora en el futuro.");
                  return;
                }
                onOpenChange(false);
                onProgramar(fecha.toISOString());
              }}
              className="btn-primary text-sm disabled:opacity-40 w-full sm:w-auto"
            >
              Programar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
